import { render, staticRenderFns } from "./DashboardJob.vue?vue&type=template&id=d894d408&scoped=true"
import script from "./DashboardJob.vue?vue&type=script&lang=js"
export * from "./DashboardJob.vue?vue&type=script&lang=js"
import style0 from "./DashboardJob.vue?vue&type=style&index=0&id=d894d408&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d894d408",
  null
  
)

export default component.exports